import type { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

/**
 * This hook returns the current user's account information.
 * MSAL's useAccount() hook should do this, but it doesn't work (only returns null)
 */
export default function useUser(): AccountInfo | null {
  const { accounts } = useMsal();

  if (accounts.length === 0) return null;
  if (accounts.length > 1) {
    console.warn("Multiple accounts detected. Using the first account.");
  }
  return accounts[0];
}
